<template>
    <div>
        <section class="py-10 py-md-14 overlay overlay-black overlay-60 bg-cover sales">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-12 col-md-10 col-lg-8 text-center">

                        <!-- Heading -->
                        <h1 class="display-2 font-weight-bold text-white">
                            We’re Here to Help.
                        </h1>

                        <!-- Text -->
                        <p class="lead text-white-75 mb-0">
                            We always want to hear from you! Let us know how we can best help you and we'll do our very best.
                        </p>

                    </div>
                </div> <!-- / .row -->
            </div> <!-- / .container -->
        </section>

        <div class="position-relative">
            <div class="shape shape-bottom shape-fluid-x svg-shim text-light">
                <svg fill="none" viewBox="0 0 2880 48" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"/>
                </svg>
            </div>
        </div>

        <section class="py-7 py-md-9 border-bottom border-gray-300" id="info">
            <div class="container">
                <div class="row">
                    <div class="col-12 text-center">

                        <!-- Button -->
                        <a class="btn btn-white btn-rounded-circle shadow mt-n11 mt-md-n13" data-toggle="smooth-scroll" href="#info">
                            <i class="fe fe-arrow-down"/>
                        </a>

                    </div>
                </div> <!-- / .row -->
                <div class="row">
                    <!--                    <div class="col-12 col-md-4 text-center border-right border-gray-300">-->

                    <!--                        &lt;!&ndash; Heading &ndash;&gt;-->
                    <!--                        <h6 class="text-uppercase text-gray-700 mb-1">-->
                    <!--                            Message us-->
                    <!--                        </h6>-->

                    <!--                        &lt;!&ndash; Link &ndash;&gt;-->
                    <!--                        <div class="mb-5 mb-md-0">-->
                    <!--                            <a href="#!" class="h4 text-primary">-->
                    <!--                                Start a chat!-->
                    <!--                            </a>-->
                    <!--                        </div>-->

                    <!--                    </div>-->
                    <div class="col-12 col-md-6 text-center border-right border-gray-300">

                        <!-- Heading -->
                        <h6 class="text-uppercase text-gray-700 mb-1">
                            Call anytime
                        </h6>

                        <!-- Link -->
                        <div class="mb-5 mb-md-0">
                            <a class="h4" href="#!">
                                +31 (0)70 808 0191
                            </a>
                        </div>

                    </div>
                    <div class="col-12 col-md-6 text-center">

                        <!-- Heading -->
                        <h6 class="text-uppercase text-gray-700 mb-1">
                            Email us
                        </h6>

                        <!-- Link -->
                        <a class="h4" href="#!">
                            connect@qlikchain.com
                        </a>

                    </div>
                </div> <!-- / .row -->
            </div>
        </section>

        <section class="pt-8 pt-md-11 pb-8 pb-md-14">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-12 col-md-10 col-lg-8 text-center">

                        <!-- Heading -->
                        <h2 class="font-weight-bold">
                            Let us hear from you directly!
                        </h2>

                        <!-- Text -->
                        <p class="font-size-lg text-muted mb-7 mb-md-9">
                            We always want to hear from you! Let us know how we can best help you and we'll do our very best.
                        </p>

                    </div>
                </div> <!-- / .row -->
                <div class="row justify-content-center">
                    <div class="col-12 col-md-12 col-lg-10">

                        <!-- Form -->
                        <form @submit.prevent="handleSubmit">
                            <div class="row">
                                <div class="col-12 col-md-6">
                                    <div class="form-group mb-5">

                                        <!-- Label -->
                                        <label for="contactName">
                                            Full name
                                        </label>

                                        <!-- Input -->
                                        <input class="form-control" data-vv-as="Full Name" id="contactName" name="name" placeholder="Full name" type="text" v-model="sales_form.name"
                                               v-validate="'required'">
                                        <div class="text-danger" v-if="submitted && errors.has('name')">{{ errors.first('name') }}</div>

                                    </div>
                                </div>
                                <div class="col-12 col-md-6">
                                    <div class="form-group mb-5">

                                        <!-- Label -->
                                        <label for="contactEmail">
                                            Email
                                        </label>

                                        <!-- Input -->
                                        <input class="form-control" data-vv-as="Email" id="contactEmail" name="email" placeholder="hello@domain.com" type="email" v-model="sales_form.email"
                                               v-validate="'required|email'">
                                        <div class="text-danger" v-if="submitted && errors.has('email')">{{ errors.first('email') }}</div>
                                    </div>
                                </div>
                            </div> <!-- / .row -->
                            <div class="row">
                                <div class="col-12">
                                    <div class="form-group mb-7 mb-md-9">

                                        <!-- Label -->
                                        <label for="contactMessage">
                                            What can we help you with?
                                        </label>

                                        <!-- Input -->
                                        <textarea class="form-control" data-vv-as="Contact Message" id="contactMessage" name="message" placeholder="Tell us what we can help you with!" rows="5"
                                                  v-model="sales_form.message" v-validate="'required'"/>
                                        <div class="text-danger" v-if="submitted && errors.has('message')">{{ errors.first('message') }}</div>
                                    </div>
                                </div>
                            </div> <!-- / .row -->
                            <div class="row justify-content-center">
                                <div class="col-auto">

                                    <!-- Submit -->
                                    <button class="btn btn-success lift" type="submit">
                                        Send message
                                    </button>

                                </div>
                            </div> <!-- / .row -->
                        </form>

                    </div>
                </div> <!-- / .row -->
            </div> <!-- / .container -->
        </section>

    </div>
</template>

<script>
    import axios from 'axios';

    export default {
        name: "SaleContact",
        data() {
            return {
                submitted: false,
                sales_form: {
                    name: null,
                    email: null,
                    message: null,
                    formContext: 'Sales'
                }
            }
        },
        methods: {
            handleSubmit(e) {
                this.submitted = true;
                this.$validator.validate()
                .then(valid => {
                    if(valid) {
                        this.save();
                    }
                });
            },
            async save() {
                let formPostUrl = 'https://4yt255du5e.execute-api.us-west-2.amazonaws.com/contactFormPost/';
                try {
                    await axios.post(formPostUrl, JSON.stringify(this.sales_form), {
                        headers: {
                            'Content-Type': 'application/json',
                        }
                    });
                    this.$swal('Request Sent Successfully', 'Our Executive will reach you soon.', 'success');
                    await this.reset();
                } catch(e) {
                    this.$swal('Request Sent Failed', 'Please try again later', 'error');
                    await this.reset();
                }
            },
            async reset() {
                this.sales_form = {
                    name: null,
                    email: null,
                    message: null,
                    formContext: 'Sales'
                };

                this.submitted = false;
            }
        }
    }
</script>

<style scoped>
    .sales {
        background-image: url(../../assets/img/covers/cover-5.jpg);
    }

    .shape {
        overflow: unset;
    }
</style>
